import Map from './Map'

export default class Preview extends Map {
    constructor(options) {
        super(options);
        this.flags.isPreview = true;
    }
}